module.exports = __webpack_public_path__ + "static/05-fd201d863471fba6fc0ab2a107896fcf.jpg";